module.exports = "<div flex ui-view=\"myFilesContent\" class=\"my-files__content\" layout=\"column\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase-app/components/_myFiles/myFiles.template.html
// module id = 1246
// module chunks = 0